<div *ngIf="flights.length > 0" class="card mb-4">
  <div class="card-header p-3 d-flex justify-content-between align-items-center">
    <h5 class="mb-0"><i class="bi bi-broadcast me-2"></i>{{ title }}</h5>
    <span class="badge bg-secondary">{{ flights.length }} {{ flights.length === 1 ? 'flight' : 'flights' }}</span>
  </div>

  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-sm align-middle mb-0">
        <thead>
          <tr class="small text-muted">
            <th scope="col">Flight</th>
            <th scope="col">Duration</th>
            <th scope="col">Area</th>
            <th scope="col">Applied</th>
            <th scope="col">Avg speed</th>
            <th scope="col">Details</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let flight of flights; let i = index; trackBy: trackByIntake">
            <td>
              <div class="fw-medium">Flight {{ i + 1 }}</div>
              <div class="small text-muted" *ngIf="flight.flightStartedAt">{{ startLabel(flight) }}</div>
            </td>
            <td class="text-nowrap">{{ duration(flight.durationSeconds) }}</td>
            <td class="text-nowrap">{{ acres(flight.workAreaAcres) }}</td>
            <td class="text-nowrap">{{ applied(flight) }}</td>
            <td class="text-nowrap">
              <span *ngIf="flight.avgSpeedMps == null && flight.detailStatus === 'processing'; else speedValue" class="text-muted fst-italic">Pending</span>
              <ng-template #speedValue>{{ speed(flight.avgSpeedMps) }}</ng-template>
            </td>
            <td>
              <span
                class="badge"
                [ngClass]="{
                  'bg-success': flight.detailStatus === 'ready',
                  'bg-warning text-dark': flight.detailStatus === 'processing',
                  'bg-secondary': flight.detailStatus === 'unavailable'
                }"
              >
                <span *ngIf="flight.detailStatus === 'processing'" class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
                {{ statusLabel(flight.detailStatus) }}
              </span>
            </td>
          </tr>
        </tbody>
        <tfoot *ngIf="flights.length > 1">
          <tr class="fw-medium">
            <td>Total</td>
            <td class="text-nowrap">{{ duration(totals.totalSeconds) }}</td>
            <td class="text-nowrap">{{ acres(totals.totalAcres) }}</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>

    <p *ngIf="anyProcessing" class="small text-muted mt-3 mb-0">
      Detailed flight data, including average speed, can arrive a little after the flight summary.
      <button type="button" class="btn btn-link btn-sm p-0 align-baseline" (click)="refresh.emit()">Refresh</button>
    </p>
  </div>
</div>
